module.exports = __webpack_public_path__ + "fonts/almoni-black-aaa.feb5a9f.woff2";